import React from 'react';
import { Check } from 'lucide-react';
import './SelectList.scss';

const CONTROL_CLASS = {
  radio: 'reops-select-list--radio',
  checkbox: 'reops-select-list--checkbox',
  checkmark: 'reops-select-list--checkmark',
};

const SelectList = ({
  as: Component = 'button',
  type = 'radio',
  title,
  description,
  icon,
  selected = false,
  disabled = false,
  width,
  className = '',
  children,
  onClick,
  ...props
}) => {
  const isNativeButton = Component === 'button';
  const controlType = CONTROL_CLASS[type] ? type : 'radio';

  const handleClick = (event) => {
    if (disabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    onClick?.(event);
  };

  const classes = [
    'reops-select-list',
    CONTROL_CLASS[controlType],
    selected ? 'is-selected' : '',
    disabled ? 'is-disabled' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <Component
      className={classes}
      type={isNativeButton ? 'button' : undefined}
      disabled={isNativeButton ? disabled : undefined}
      aria-disabled={!isNativeButton && disabled ? true : undefined}
      aria-pressed={isNativeButton ? selected : undefined}
      data-selected={selected ? 'true' : 'false'}
      onClick={handleClick}
      style={width ? { width } : undefined}
      {...props}
    >
      {controlType !== 'checkmark' ? (
        <span className="reops-select-list__control" aria-hidden="true" />
      ) : null}
      {icon ? <span className="reops-select-list__icon" aria-hidden="true">{icon}</span> : null}
      <span className="reops-select-list__content">
        <span className="reops-select-list__title-row">
          <span className="reops-select-list__title">{title || children}</span>
          {controlType === 'checkmark' ? (
            <span className="reops-select-list__check" aria-hidden="true">
              <Check size={20} strokeWidth={2.4} />
            </span>
          ) : null}
        </span>
        {description ? <span className="reops-select-list__description">{description}</span> : null}
      </span>
    </Component>
  );
};

export default SelectList;
